import ReactGA from "react-ga4";

const MEASUREMENT_ID = process.env.REACT_APP_MEASUREMENT_ID;

export const initGA = () => {
  if (MEASUREMENT_ID) {
    ReactGA.initialize(MEASUREMENT_ID);
  } else {
    console.warn("Google Analytics MEASUREMENT_ID not found in environment variables");
  }
};

export const logPageView = () => {
  ReactGA.send({ hitType: "pageview", page: window.location.pathname });
};
